module.exports = __webpack_public_path__ + "static/media/3. N8, Superficie Sólida, 37 x 87 x 55 cm, 2019 copy.0f79dacd.png";